export default {
    hrn: '₴',
    hasRemarks: 'Есть замечание!',
    days: ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
    validate: {
        Auth: {
            login: {
                required: 'Введите логин '
            },
            password: {
                required: 'Введите пароль',
                minLength: 'Минимальная длина пароля - 6'
            },
            phone: {
                number: ''
            }
        },
        Resale: {
            compensation: {
                required: 'Введите компенсацию',
                numeric: 'Компенсация должна быть целым числом'
            },
            price: {
                required: 'Введите цену',
                numeric: 'Цена должна быть целым числом'
            },
            delay: {
                required: 'Введите задержку',
                numeric: 'Задержка должна быть целым числом'
            },
            compensationInPercent: {
                required: 'Введите компенсацию в процентах',
                numeric: 'Компенсация в процентах должна быть целым числом',
                minValue: 'Значение не может быть меньше 0',
                maxValue: 'Значение не может быть больше 100'
            },
            priceInPercent: {
                required: 'Введите цену в процентах',
                numeric: 'Цена в процентах должна быть целым числом',
                minValue: 'Значение не может быть меньше 0',
                maxValue: 'Значение не может быть больше 100'
            },
            optionClassId: {
                required: 'Выберите опцию'
            }
        },
        Brand: {
            code: {
                required: 'Введите код'
            },
            title: {
                required: 'Введите название'
            },
            phoneNumber: {
                required: 'Введите номер телефона'
            },
            tax: {
                required: 'Введите сбор',
                numeric: 'Сбор должен быть числом'
            }
        },
        Establishment: {
            name: {
                required: 'Это поле обязательно'
            },
            cookTime: {
                required: 'Это поле обязательно',
                numeric: 'Значение должно быть числом'
            },
            commission: {
                required: 'Это поле обязательно',
                decimal: 'Значение должно быть числом',
                max: 'Значение должно быть не меньше 0',
                min: 'Значение должно быть не больше 100',
            },
            margin: {
                required: 'Это поле обязательно',
                decimal: 'Значение должно быть числом',
                max: 'Значение должно быть не меньше 0',
                min: 'Значение должно быть не больше 100',
            },
            minimalPrice: {
                required: 'Это поле обязательно',
                numeric: 'Значение должно быть числом'
            },
            place: {
                required: 'Это поле обязательно'
            },
            type: {
                name: 'Это поле обязательно',
            },
            category: {
                required: 'Это поле обязательно'
            },
            brand: {
                required: 'Это поле обязательно'
            },
            image: {
                required: 'Выберите изображение'
            }
        },
        Product: {
            'name:uk': {
                required: 'Это поле обязательно'
            },
            'name:en': {
                required: 'Это поле обязательно'
            },
            'name:ru': {
                required: 'Это поле обязательно'
            },
            weight: {
                required: 'Это поле обязательно',
                numeric: 'Значение должно быть числом',
                maxLength: 'Максимальная длина - 6 символов'
            },
            price: {
                required: 'Это поле обязательно',
                numeric: 'Значение должно быть числом',
                maxLength: 'Максимальная длина - 6 символов'
            },
            'shortDescription:uk': {
                maxLength: 'Максимальная длина - 255 символов'
            },
            'shortDescription:ru': {
                maxLength: 'Максимальная длина - 255 символов'
            },
            'shortDescription:en': {
                maxLength: 'Максимальная длина - 255 символов'
            },
            'detailedDescription:uk': {
                maxLength: 'Максимальная длина - 400 символов'
            },
            'detailedDescription:ru': {
                maxLength: 'Максимальная длина - 400 символов'
            },
            'detailedDescription:en': {
                maxLength: 'Максимальная длина - 400 символов'
            },
            establishmentAddressId: {
                required: 'Это поле обязательно'
            },
            establishment: {
                required: 'Это поле обязательно'
            },
            status: {
                required: 'Это поле обязательно',
            },
            brand: {
                required: 'Это поле обязательно'
            },
            section: {
                required: 'Это поле обязательно'
            },
            image: {
                required: 'Выберите изображение'
            },
        },
        Notifications: {
            title: {
                required: 'Введите заголовок'
            },
            body: {
                required: 'Введите текст',
                maxLength: 'Слишком длинный текст'
            }
        },
        Addresses: {
            street: {
                required: 'Введите название улицы'
            },
            name: {
                required: 'Введите название места'
            },
            city: {
                required: 'Введите город'
            },
            houseNumber: {
                required: 'Введите номер дома'
            },
            latitude: {
                required: 'Введите широту',
                demical: 'Введите широту в цифрах'
            },
            longitude: {
                required: 'Введите долготу',
                demical: 'Введите долготу в цифрах'
            }
        },
        Bonuses: {
            amount: {
                required: 'Введите сумму бонуса',
                numeric: 'Введите сумму в цифрах',
                minValue: 'Сумма должна быть больше 0 грн.',
            },
            brandId: {
                required: 'Выберите бренд'
            },
            phones: {
                required: 'Введите номера телефонов'
            },
            callSigns: {
                required: 'Введите позывные водителей'
            },
            bonusUseLimit: {
                title: {
                    required: "Введите имя системы"
                },
                description: {
                    required: "Введите описание системы"
                },
                bonusFrequency: {
                    required: 'Введите частоту использования бонуса',
                    numeric: 'Введите частоту в цифрах',
                    minValue: 'Частота должна быть больше 0'
                },
                bonusValue: {
                    required: 'Введите сумму бонуса',
                    numeric: 'Введите сумму в цифрах',
                    minValue: 'Сумма должна быть больше 0 грн.'
                },
                bonusValueFromDriver: {
                    required: 'Введите сумму бонуса от водителя',
                    maxValue: 'Не должна быть больше, чем сумма бонуса',
                    numeric: 'Введите сумму в цифрах',
                    minValue: 'Сумма должна быть больше 0 грн.'
                },
                startDate: {
                    required: 'Введите дату старта программы'
                },
                endDate: {
                    required: 'Введите дату окончания программы'
                }
            },
            bonusSystem: {
                title: {
                    required: "Введите имя системы"
                },
                description: {
                    required: "Введите описание системы"
                },
                bonusFrequency: {
                    required: 'Введите частоту использования бонуса',
                    numeric: 'Введите частоту в цифрах',
                    minValue: 'Частота должна быть больше 0'
                },
                bonusValue: {
                    required: 'Введите сумму бонуса',
                    numeric: 'Введите сумму в цифрах',
                    minValue: 'Сумма должна быть больше 0 грн.'
                },
                bonusMaxAmount: {
                    numeric: 'Введите максимальный размер бонуса в цифрах'
                },
                skip: {
                    numeric: 'Введите количество пропусков в цифрах'
                },
                startDate: {
                    required: 'Введите дату старта программы'
                },
                endDate: {
                    required: 'Введите дату окончания программы'
                }
            }
        },
        Report: {
            name: {
                required: 'Введите название отчета',
                minLength: 'Минимальное количество символов - 2',
                maxLength: 'Максимальное количество символов - 255'
            },
            category: {
                maxLength: 'Максимальное количество символов - 255',
            },
            sqlQuery: {
                required: 'Введите SQL запрос'
            }
        },
        Operators: {
            companyName: {
                required: 'Введите название',
                minLength: 'Минимальное количество символов - 3'
            }
        },
        User: {
            firstName: {
                required: 'Введите имя',
                minLength: 'Минимальное количество символов - 2',
                maxLength: 'Максимальное количество символов - 30'
            },
            lastName: {
                required: 'Введите фамилию',
                minLength: 'Минимальное количество символов - 2',
                maxLength: 'Максимальное количество символов - 30'
            },
            middleName: {
                required: 'Введите отчество',
                minLength: 'Минимальное количество символов - 2',
                maxLength: 'Максимальное количество символов - 30'
            },
            loginName: {
                required: 'Введите логин',
                minLength: 'Минимальное количество символов - 2',
                maxLength: 'Максимальное количество символов - 30',
                alphaNum: 'Допускаются символы латинского алфавита'
            },
            phoneNumber: {
                required: 'Введите номер телефона'
            },
            password: {
                required: 'Введите пароль',
                minLength: 'Минимальное количество символов - 6',
                maxLength: 'Максимальное количество символов - 30'
            },
            email: {
                required: 'Поле обязательное',
                email: 'Введите корректный адрес электронной почты'
            },
            comment: {
                maxLength: 'Длина примечания превышает 255 символов'
            },
            brandId: {
                required: 'Выберите бренд'
            }
        },
        DriverDetails: {
            callSign: {
                required: 'Введите позывной'
            },
            commissionId: {
                required: 'Введите тариф'
            },
            minBalance: {
                required: 'Введите минимальный баланс',
                numeric: 'Введены неверные данные',
                maxValue: 'Введенный баланс превышает допустимый',
                minValue: 'Введенный баланс ниже допустимого'
            },
            address: {
                required: 'Поле обязательное'
            },
            passportNumber: {
                required: 'Поле обязательное'
            },
            passportIssuedBy: {
                required: 'Поле обязательное'
            },
            passportIssuedWhen: {
                required: 'Поле обязательное'
            },
            identificationCode: {
                required: 'Поле обязательное'
            }
        },
        DriverLikes: {
            comment: {
                required: 'Поле обязательное'
            }
        },
        CommissionTransfer: {
            commissionId: {
                required: 'Выберите комиссию'
            },
            commissionSystemId: {
                required: 'Выберите систему комиссий'
            }
        },
        Car: {
            year: {
                required: 'Поле обязательное',
                numeric: 'Введите год выпуска авто'
            },
            model: {
                required: 'Поле обязательное'
            },
            color: {
                required: 'Поле обязательное'
            },
            make: {
                required: 'Поле обязательное'
            },
            number: {
                required: 'Поле обязательное'
            }
        },
        DriverPayment: {
            paymentSum: {
                required: 'Введите сумму',
                numeric: 'Допускаются только цифры'
            },
            paymentComment: {
                maxLength: 'Длина комментария превышает 255 символов',
                required: 'Введите комментарий к платежу'
            },
            penaltyComment: {
                required: 'Введите комментарий к штрафу'
            },
            penaltyId: {
                required: 'Выберите штраф'
            },
            paymentType: {
                required: 'Выберите тип платежа'
            },
            orderId: {
                custom: 'Введите номер заказа'
            }
        },
        PaymentType: {
            name: {
                required: 'Введите название'
            },
            description: {
                required: 'Введите описание'
            }
        },
        DriverPenalty: {
            title: {
                required: 'Введите название штрафа'
            },
            fixedPenalty: {
                required: 'Введите суму штрафа',
                demical: 'Введите суму штрафа в цифрах'
            },
            brandId: {
                required: 'Выберите бренд'
            }
        },
        Options: {
            optionName: {
                required: 'Введите название тарифа'
            },
            startPrice: {
                required: 'Введите суму подачи',
                demical: 'Введите суму подачи в цифрах'
            },
            priceForKm: {
                required: 'Введите плату за километр',
                demical: 'Введите плату за километр в цифрах'
            },
            priceForWaiting: {
                required: 'Введите плату за ожидание',
                demical: 'Введите плату за ожидание в цифрах'
            },
            minPrice: {
                required: 'Введите минимальную суму',
                numeric: 'Введите минимальную суму в цифрах'
            },
            multiplier: {
                required: 'Введите множитель тарифа',
                demical: 'Введите множитель тарифа в цифрах'
            },
            multiplierForDriver: {
                required: 'Введите множитель тарифа для водителя',
                demical: 'Введите множитель тарифа для водителя в цифрах'
            },
            brandId: {
                required: 'Выберите бренд'
            }
        },
        OptionClasses: {
            className: {
                required: 'Введите название'
            }
        },
        DriverCommission: {
            title: {
                required: 'Введите название комиссии'
            },
            fixedPerOrder: {
                required: 'Введите плата за заказ',
                demical: 'Введите плата за заказ в цифрах'
            },
            fixedPerDay: {
                required: 'Введите плату за день работы',
                demical: 'Введите плату за день работы в цифрах'
            },
            fixedPerDeliveryOrder: {
                required: 'Введите плату за заказ доставки',
                demical: 'Введите плату за заказ доставки в цифрах'
            },
            percentagePerDeliveryOrder: {
                required: 'Введите плату за заказ доставки',
                demical: 'Введите плату за заказ доставки в цифрах'
            },
            perDayType: {
                required: 'Введите тип платы за день'
            },
            fixedPerWeek: {
                required: 'Введите плату за неделю работы',
                demical: 'Введите плату за неделю работы в цифрах'
            },
            fixedPerMonth: {
                required: 'Введите плату за месяц работы',
                demical: 'Введите плату за месяц работы в цифрах'
            },
            deliveryDelay: {
                required: 'Введите задержку',
                demical: 'Введите задержку в цифрах'
            },
            brandId: {
                required: 'Выберите бренд'
            }
        },
        DriverCommissionRecalculate: {
            distance: {
                required: 'Введите расстояние',
                minValue: 'Значение должно быть больше 0'
            },
            downtime: {
                required: 'Введите простой',
                minValue: 'Значение должно быть больше 0'
            }
        },
        PhotoReport: {
            reason: {
                comment: {
                    required: 'Введите комментарий'
                },
                name: {
                    required: 'Введите название причины'
                },
                types: {
                    name: {
                        required: 'Введите тип фото'
                    }
                }
            },
            photoRequest: {
                name: {
                    required: 'Введите название фотоотчёта'
                },
                reasonId: {
                    required: 'Введите причину'
                },
                brandId: {
                    required: 'Выберите бренд'
                },
                callSigns: {
                    required: 'Введите позывные'
                },
                checkCallSign: {
                    required: 'Введите позывной'
                }
            }
        },
        CommissionSystems: {
            name: {
                required: 'Введите название'
            },
            brandId: {
                required: 'Выберите бренд'
            },
            period: {
                required: 'Введите период',
                numeric: 'Некорректное значение',
                min: 'Меньше минимума'
            }
        },
        Forms: {
            name: {
                required: 'Введите название'
            }
        },
        FormAnswers: {
            phoneNumber: {
                required: 'Введите номер телефона',
                length: 'Номер телефона некорректный'
            },
            formId: {
                required: 'Выберите анкету'
            },
            status: {
                required: 'Укажите статус'
            }
        },
        PerOrderBorder: {
            leftBorder: {
                required: 'Введите левую границу',
                numeric: 'Введите левую границу в цифрах'
            },
            rightBorder: {
                required: 'Введите правую границу',
                numeric: 'Введите правую границу в цифрах',
                minValue: 'Значение правой границы должно превышать значение левой границы'
            },
            staticValue: {
                required: 'Введите статическую комиссию',
                demical: 'Введите статическую комиссию в цифрах'
            },
            percentValue: {
                required: 'Введите процентную комиссию',
                demical: 'Введите процентную комиссию в цифрах'
            }
        },
        TechnicalSupport: {
            type: {
                required: 'Выберите тип звонка'
            },
            phoneNumber: {
                required: 'Введите номер телефона',
                length: 'Номер телефона некорректный'
            },
            status: {
                required: 'Выберите статус'
            },
            reason: {
                required: 'Выберите причину'
            },
            customReason: {
                required: 'Введите причину'
            },
            comment: {
                maxLength: 'Максимальная длина - 255 символов'
            }
        }
    },
    menu: {
        technicalSupport: 'Техническая поддержка',
        deliveryReports: 'Отчеты доставки',
        receiveOrders: 'Прием заказов',
        formAnswers: 'Опросы',
        driverArticleEditor: 'Редактирование водительской новости',
        articleList: 'Список новостей',
        importProducts: 'Импорт товаров',
        dispatcher: {
            title: 'Оператор',
            receiveOrders: 'Прием заказов',
            formAnswers: 'Опросы',
            technicalSupport: 'Техническая поддержка'
        },
        // --- Delivery ---
        delivery: {
            title: 'Доставка',
            establishmentsCategories: 'Категории заведений',
            establishmentsTypes: 'Типы заведений',
            establishments: 'Заведения',
            sections: 'Разделы',
            products: 'Товары',
            importProducts: 'Импорт товаров',
            deliveryReports: 'Отчеты доставки'
        },
        establishmentsCategories: 'Категории заведений',
        establishmentsTypes: 'Типы заведений',
        establishments: 'Заведения',
        sections: 'Разделы',
        products: 'Товары',
        // --- Delivery end ---
        driverNews: {
            title: 'Водительские новости',
            articleList: 'Список новостей',
            addDriverArticle: 'Создание новости',
        },
        addDriverArticle: 'Создание водительской новости',
        history: 'История',
        map: 'Карта',
        finances: {
            title: 'Финансы',
            tariffs: 'Тарифы',
            commissions: 'Комиссии',
            'commission-systems': 'Системы комиссий',
            penalties: 'Штрафы',
            optionClasses: 'Классы опций',
            paymentTypes: 'Типы платежей'
        },
        users: {
            title: 'Списки',
            operators: 'Пользователи',
            drivers: 'Водители',
            clients: 'Клиенты'
        },
        settings: {
            title: 'Настройки',
            admin: 'Для администратора',
            boss: 'Для директора'
        },
        resales: 'Перепродажа',
        brands: 'Бренды',
        bonuses: {
            title: 'Бонусы',
            driver: 'Для водителя',
            client: 'Для клиента'
        },
        photoReport: {
            title: 'Фотоотчет',
            reasons: 'Список причин',
            review: 'Рассмотрение фотоотчёта',
            reasonCreate: 'Создание причины',
            requestCreate: 'Создание фотоотчёта',
            reports: 'Список фотоотчётов'
        },
        logging: 'Активность',
        loggingEditor: 'Редактирование активности',
        login: 'Вход',
        reports: 'Отчеты',
        addresses: 'Адреса',
        notifications: 'Уведомления',
        logout: 'Выйти',
        forms: 'Анкеты'
    },
    models: {
        Driver: {
            make: 'Марка автомобиля',
            year: 'Год выпуска автомобиля',
            color: 'Цвет автомобиля',
            email: 'Почта',
            model: 'Модель автомобиля',
            number: 'Гос. номер автомобиля',
            pledge: 'Залог',
            address: 'Адрес',
            brandId: 'Номер бренда',
            brand: 'Бренд',
            comment: 'Комментарий',
            options: 'Опции',
            callSign: 'Позывной',
            lastName: 'Фамилия',
            firstName: 'Имя',
            commission: 'Комиссия',
            commissionSystem: 'Система Комиссии',
            middleName: 'Отчество',
            minBalance: 'Минимальный баланс',
            phoneNumber: 'Телефон',
            commissionId: 'Номер комиссии',
            additionalAdresses: 'Дополнительные адреса',
            additionalPhoneNumbers: 'Дополнительный телефон',
            passportNumber: 'Серия и номер',
            passportIssuedBy: 'Выдан (кем)',
            passportIssuedWhen: 'Выдан (когда)',
            identificationCode: 'Идентификационный код',
            comments: 'Комментарии',
            leaderId: 'ID лидера'
        },
        Client: {
            email: 'Почта',
            brandId: 'Номер бренда',
            brand: 'Бренд',
            birthday: 'Дата рождения',
            lastName: 'Фамилия',
            middleName: 'Отчество',
            roleName: 'Роль',
            firstName: 'Имя',
            phoneNumber: 'Номер телефона',
            comment: 'Комментарий'
        },
        Operator: {
            id: 'Id',
            email: 'Почта',
            brandId: 'Номер бренда',
            brand: 'Бренд',
            comment: 'Комментарий',
            lastName: 'Фамилия',
            roleName: 'Роль',
            firstName: 'Имя',
            loginName: 'Логин',
            middleName: 'Отчество',
            phoneNumber: 'Номер телефона',
            canEditClients: 'Отображать заказы других операторов',
            canEditDrivers: 'Возможность редактирования водителей',
            canChangeOptionLevel: 'Возможность изменения уровня опций'
        },
        ClientBonus: {
            title: 'Название бонуса',
            brandId: 'Номер бренда',
            brand: 'Бренд',
            endDate: 'Дата окончания',
            isActive: 'статус Активный',
            startDate: 'Дата начала',
            bonusValue: 'Сумма бонуса',
            description: 'Описание',
            bonusFrequency: 'Частота использования бонуса',
            bonusValueFromDriver: 'Сумма бонуса от водителя'
        },
        Tariff: {
            hidden: 'Скрытый',
            brandId: 'Номер бренда',
            minPrice: 'Минимальная цена',
            brand: 'Бренд',
            districtName: 'Район',
            optionName: 'Тариф',
            className: 'Тип',
            districtId: 'Район',
            multiplier: 'Множитель тарифа',
            priceForKm: 'Цена за км',
            startPrice: 'Начальная цена',
            description: 'Описание',
            internal: 'Внутренний',
            priceForWaiting: 'Простой',
            defaultOptions: 'Базовый',
            multiplierForDriver: 'Множитель для водителей',
            numberOfSits: 'Количество мест'
        },
        Resale: {
            delay: 'Задержка',
            price: 'Цена',
            compensation: 'Компенсация',
            priceInPercent: 'Цена в процентах',
            compensationInPercent: 'Компенсация в процентах'
        },
        Commission: {
            title: 'Название комиссии',
            brandId: 'Номер бренда',
            brand: 'Бренд',
            isDefault: 'По умолчанию',
            perDayType: 'Тип платы за день',
            fixedPerDay: 'Плата за день работы',
            fixedPerWeek: 'Плата за неделю работы',
            deliveryDelay: 'Задержка',
            fixedPerMonth: 'Плата за месяц работы',
            fixedPerOrder: 'Плата за заказ'
        },
        CommissionBorder: {
            leftBorder: 'Левая граница',
            rightBorder: 'Правая граница',
            staticValue: 'Статическая комиссия',
            percentValue: 'Процентная комиссия',
            commissionTitle: 'Название комиссии'
        },
        Penalty: {
            title: 'Название штрафа',
            brandId: 'Номер бренда',
            brand: 'Бренд',
            fixedPenalty: 'Сумма штрафа'
        },
        DriverBonus: {
            title: 'Название водительского бонуса',
            brandId: 'Номер бренда',
            brand: 'Бренд',
            endDate: 'Дата окончания',
            isActive: 'статус Активный',
            startDate: 'Дата начала',
            bonusValue: 'Сумма бонуса',
            description: 'Описание',
            bonusFrequency: 'Частота использования бонуса',
            bonusMaxAmount: 'Максимальный размер бонуса',
            takeOtherBrandOrders: 'Заказы других служб'
        },
        Settings: {
            value: 'Значение',
            comment: 'Комментарий',
            forDirector: 'для директора',
            forAdmin: 'для администратора'
        },
        Report: {
            name: 'Название',
            category: 'Категорию',
            sqlQuery: 'Sql запрос',
            meta: 'SQL метаданные',
            useDates: 'Фильтр по дате',
            useTimes: 'Фильтр по времени',
            useQuery: 'Текстовый запрос',
            useBrand: 'Фильтр по брендам',
            useCorp: 'Для корпоративных клиентов',
            useCompany: 'Фильтр по компаниям'
        },
        Payment: {
            withdrawal: 'Вывод',
            deposit: 'Пополнение',
            penalty: 'Штраф'
        }
    },
    pages: {
        Delivery: {
            addressSchedule: "График работы адреса",
            Categories: {
                visibility: {
                    shown: 'Отображается',
                    hidden: 'Скрыта'
                },
                deleting: 'Удаление категории',
                areYouSureToDelete: 'Вы действительно хотите удалить категорию?'
            },
            ImportProducts: {
                chooseAFile: 'Выберите файл',
                fileToImport: 'Файл для импорта',
                validationResults: 'Результат проверки',
                chooseEstablishmentAddress: 'Выберите адрес заведения',
                productErrors: 'Ошибки в товарах',
                newSections: 'Новые разделы',
                products: 'Товары',
                validate: 'Проверить',
                howToCreateImportFile: 'Как создать файл для импорта?',
                importFileInstructions: `Це zip архів з csv файлом і картинками
Csv файл має бути з назвою import.csv
Колонки в csv файлі:
Name назва продукту
Count кількість продукту
QuantityType - тип кількості продукту (г, мл, шт, кг)
Price - ціна
Section - назва розділу
ShortDescription - короткий опис
DetailedDescription - опис продукту
Image - назва файлу картинки`,
                productStatuses: {
                    new: 'Новые',
                    updated: 'Обновленные',
                },
                import: 'Импортировать',
            },
            Products: {
                price: 'Цена',
                section: 'Раздел',
                amount: 'Количество',
                picture: 'Картинка',
                shortDescription: 'Краткое описание',
                detailedDescription: 'Подробное описание',
                new: 'Новый'
            },
            photo: 'Фото',
            airAlarm: 'Воздушная тревога'
        },
        History: {
            status: 'Статус',
            deliveryStatus: 'Статус доставки',
            filterTitle: 'Сбросить фильтр',
            reason: 'Причина отмены',
            brand: 'Бренд',
            all: 'Все',
            scope: 'Цель',
            establishment: 'Заведение',
            table: {
                actions: '',
                id: '#',
                deliveryCancelReason: 'Причина отмены',
                createdAt: 'Время создания',
                gettingOrderTime: 'Время взятия заказа',
                status: 'Статус',
                statusesHistory: 'История статусов',
                client: 'Клиент',
                address: 'Адрес подачи',
                cookTime: 'Время приготовления',
                additionAddresses: 'Адреса поездки',
                options: 'Опции',
                arrivalTime: 'Подача',
                car: 'Машина',
                brandId: 'Бренд',
                establishment: 'Заведение',
                operator: 'Диспетчер',
                comments: 'Комментарии',
                price: 'Цена',
                courierStatus: 'Статус курьера',
                problem: 'Замечание',
                countOfPersons: 'Приборы',
                products: 'Товары',
                manager: 'Менеджер',
                managerPhoneNumber: 'Номер менеджера',
                calculatedPrice: 'Расчетная цена',
                commentForEstablishment: 'Комментарий для заведения',
                tips: 'На чай',
                route: 'Карта',
                routeLength: 'Длина маршрута',
                stayTime: 'Простой'
            }
        },
        DashboardMap: {
            settings: 'Настройка карты',
            showDrivers: 'Отображать водителей',
            showGroupOrders: 'Отображать группы заказов',
            showNewOrders: 'Отображать новые заказы',
            orderIdPlaceholder: 'Введите номер заказа',
            allBrands: 'Все бренды',
            errors: {
                accessDenied: 'У Вас нет прав для просмотра этого заказа.',
                orderNotFound: 'Заказа с указанным Id не существует.',
                noRouteInfo: 'В данном заказе нет информации о маршруте.'
            }
        },
        Auth: {
            title: 'Вход в систему',
            login: 'Логин',
            password: 'Пароль',
            phone: 'SIP'
        },
        Settings: {
            requiredBrand: 'Выберите бренд, для которого вы хотите отобразить настройки',
            brand: 'Бренд',
            edit: 'Редактирование настройки',
            default: 'Дефолтные настройки',
            usedDefault: 'Основные настройки используются для этого бренда',
            action: 'Выкл/Вкл',
            table: {
                key: 'Ключ',
                value: 'Значение',
                type: 'Тип значения',
                comment: 'Комментарий',
                action: 'Действия'
            },
            types: {
                bots: 'Боты',
                driverUdp: 'Водительское приложение',
                notifications: 'Уведомления',
                payments: 'Платежные системы',
                publicApi: 'Публичный сайт',
                karma: 'Карма',
                public: 'Операторское приложение',
                paymentApi: 'Платежки',
                businessSystem: 'Бизнес система',
                delivery: 'Доставка'
            }
        },
        Brands: {
            brandHasActiveEstablishments: 'Выбранный бренд имеет активные заведения',
            cannotRemoveTitle: 'Невозможно удалить бренд',
            filters: {
                query: 'Запрос',
                removed: 'Удаленные'
            },
            table: {
                code: 'Код',
                is_vip: 'VIP',
                title: 'Название',
                phoneNumber: 'Телефон',
                domain: 'Домен',
                defaultOptionId: 'Опция',
                fromCurbOptionId: 'Опция для подсадки',
                tax: 'Сбор',
                actions: 'Действия',
                removeTitle: 'Удаление бренда',
                removeQuestion: 'Вы действительно хотите удалить этот бренд ?'
            }
        },
        Forms: {
            table: {
                id: 'Номер анкеты',
                name: 'Название',
                description: 'Описание',
                count: 'Количество компонентов',
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
                actions: 'Действия',
                removeQuestion: 'Вы действительно хотите удалить анкету ?',
                removeDescription: 'Эта анкета будет полностью удалена из системы'
            },
            editor: {
                create: 'Создание анкеты',
                edit: 'Редактирование анкеты',
                fill: 'Наполнение анкеты'
            },
            components: {
                text: 'Текст',
                type: 'Тип',
                order: 'Порядок',
                options: 'Опции',
                emptyOptions: 'Опции не созданы',
                actions: 'Действия'
            },
            types: {
                text: 'Текст',
                'simple-question': 'Простой вопрос',
                'complex-question': 'Развернутый вопрос',
                'single-choice': 'Один вариант',
                'multiple-choice': 'Несколько вариантов'
            }
        },
        FormAnswers: {
            history: 'История опросов',
            table: {
                id: 'Номер обращения',
                status: 'Статус',
                comment: 'Комментарий',
                client: 'Клиент',
                phoneNumber: 'Номер телефона',
                form: 'Название',
                operator: 'Оператор',
                createdAt: 'Создано',
                actions: 'Действия'
            },
            statuses: {
                'new': 'Новый',
                'not-interested': 'Не интересует',
                'cannot-connect': 'Отсутствует связь',
                'call-terminated': 'Обрыв звонка',
                'to-quality-control': 'На отдел качества',
                'call-back-later': 'Перезвонить позже',
                'success': 'Успешно',
                'app-success': 'Успешно - приложение',
                'telephony-success': 'Успешно - телефония',
                'quality-control-success': 'Отдел качества - решено',
                'quality-control-failure': 'Отдел качества - не решено',
                'returned-promotion-retain': 'Вернулся сам - не удалять из акции',
                'returned-promotion-remove': 'Вернулся сам - удалить из акции'
            },
            editor: {
                title: 'Анкета',
                phoneNumber: 'Номер телефона',
                formId: 'Анкета',
                status: 'Статус',
                comment: 'Комментарий',
                questions: 'Вопросы'
            }
        },
        ResalesList: {
            brand: 'Бренд',
            switch: 'Продавец/Покупатель',
            edit: 'Редактирование перепродажи',
            buyer: 'Покупатель',
            dealer: 'Продавец',
            compensation: 'Компенсация',
            price: 'Цена',
            compensationInPercent: 'Компенсация в процентах',
            priceInPercent: 'Цена в процентах',
            delay: 'Задержка',
            percents: 'Выбрать в процентах'
        },
        BrandEditor: {
            create: 'Создание бренда',
            edit: 'Редактирование бренда',
            code: 'Код',
            title: 'Название',
            phoneNumber: 'Телефон',
            domain: 'Домен',
            defaultOptionId: 'Опция',
            fromCurbOptionId: 'Опция для подсадки',
            tax: 'Сбор'
        },
        Notifications: {
            success: 'Успешно',
            failure: 'Не успешно',
            count: 'Количество уведомлений',
            callSigns: 'Позывные',
            brands: 'Бренды',
            driverStatus: 'Статус водителя',
            optionClasses: 'Классы опций',
            commissions: 'Комиссии',
            startDate: 'Начальная дата',
            endDate: 'Конечная дата',
            sentNotification: 'Отправить уведомление',
            title: 'Заголовок',
            body: 'Текст',
            imageLink: 'Ссылка на картинку',
            description: 'Уведомление будет отправлено списку выбранных водителей',
            result: 'Результат'
        },
        ReceiveOrders: {
            assign: 'Назначить',
            assignDriver: 'Назначить водителя на заказ',
            assignedSuccessfully: 'Водитель {0} успешно назначен на заказ.',
            assignError: 'Ошибка при назначении водителя на заказ.',
            title: 'Заказы',
            ordersSearch: 'Поиск',
            createOrderTitle: 'Заказ',
            customer: 'Заказчик',
            gotAProblem: 'Есть замечание!',
            address: 'Адрес подачи',
            house: 'Дом',
            street: 'Улица',
            search: 'Начните вводить для поиска ...',
            outCity: 'За городом',
            comment: 'Комментарий',
            commentLabel: 'Комментарий (квартира / подъезд / что везти)',
            addAddress: 'Добавить адрес',
            arrival: 'Адрес прибытия',
            noAddress: 'Адрес не указан',
            changeNumber: 'Сменить номер',
            copyNumber: 'Скопировать номер',
            when: 'Когда',
            now: 'Сейчас',
            today: 'Сегодня',
            tomorrow: 'Завтра',
            brand: 'Бренд',
            autoType: 'Тип авто',
            autoRequirements: 'Требования к автомобилю',
            tip: 'Добавить к сумме заказа',
            orderHistory: 'История заказов',
            waiting: 'Ожидание',
            cancel: 'Отменить',
            callSign: 'Позывной',
            driver: 'Водитель',
            preOrder: 'Предзаказ',
            minPreOrderTime: 'Минимальное время для предзаказа -',
            forced: 'Принудительное назначение',
            nearestCars: 'Ближайшие автомобили',
            appoint: 'Назначить',
            forTea: 'На чай',
            sum: 'В сумме',
            route: 'Маршрут',
            goBack: 'Вернуться',
            acceptOrder: 'Принять заказ',
            orderCancellation: 'Отмена заказа',
            enterCancelReason_textWillBeSentToClient: 'Укажите причину отказа от заказа. Введенный текст отобразится клиенту',
            switchStatus: 'Сменить статус',
            prepareTime: 'Время приготовления (в минутах)',
            delegationOfOrders: 'Передача заказов другому оператору',
            chooseOrderReceiver: 'Кому передать Ваши заказы?',
            transfer: 'Передать',
            operatorName: 'Имя оператора',
            km: 'км',
            hrn: 'грн',
            min: 'мин',
            recalculate: 'Пересчитать',
            duplicate: 'Дублировать',
            noCars: 'Нет машин',
            noPhone: 'Номер телефона некорректный',
            backToSearch: 'Вернуть в поиск',
            orderAddress: 'Местонахождение заказа',
            calculate: 'Рассчитать',
            save: 'Сохранить',
            establishment: 'Заведение',
            clientAddress: 'Адрес клиента',
            establishmentManager: 'Менеджер заведения',
            client: 'Клиент',
            countOfPersonsDeclinated1: 'на %s персону',
            countOfPersonsDeclinated2: 'на %s персоны',
            countOfPersonsDeclinated5: 'на %s персон',
            operator: 'Операторская',
            orderDetails: 'Детали заказа',
            commentForEstablishment: 'Комментарий к заказу',
            edit: 'Редактировать',
            searchAuto: 'Поиск машины',
            searchDriver: 'Введите позывной водителя',
            searchCourier: 'Поиск курьера',
            discount: 'Скидка',
            corporateUser: 'Корпоративный пользователь',
            bonusesDiscount: 'Поездок до скидки',
            increaseTariff: 'Повышение тарифов',
            cancelOrderDetails: {
                details: 'Детали отмены',
                questionType: 'Тип вопроса',
                explanation: 'Уточнение',
                resolved: 'Решено',
                unresolved: 'Не решено',
                questionsList: {
                    'with-driver': 'Вопрос с водителем',
                    'with-client': 'Вопрос с клиентом'
                },
                explanationsList: {
                    'corporation-sum': 'Сумма по корпорации',
                    'app-question': 'Вопрос по приложению',
                    'order': 'Вопрос по заказу',
                    'pre-order': 'Вопрос по предзаказу',
                    'accident-call': 'Ошибочный звонок',
                    'sos': 'SOS',
                    'no-sms': 'Нет смс',
                    'no-car': 'Нет авто',
                    'tariffs-explanation': 'Уточнение тарифов',
                    'complaint-receive': 'Прием жалобы',
                    'additional-calls': 'Дополнительные звонки',
                    'admin-transfer': 'Передача администратору',
                    'manager-transfer': 'Передача руководству',
                    'custom': 'Другое'
                }
            },
            reducedTariff: 'Пониженный тариф',
            previousTariff: 'Тариф предыдущего заказа - <b>"{0}"</b>',
            settingCurrentOptionLevel: 'Изменение текущего уровня опций',
            currentOptionLevel: 'Текущий уровень опций',
            newValue: 'Новое значение'
        },
        Addresses: {
            table: {
                street: 'Улица',
                name: 'Место',
                'street:uk': 'Улица (uk)',
                'name:uk': 'Место (uk)',
                'city:uk': 'Город (uk)',
                'street:ru': 'Улица (ru)',
                'name:ru': 'Место (ru)',
                'city:ru': 'Город (ru)',
                'street:en': 'Улица (en)',
                'name:en': 'Место (en)',
                'city:en': 'Город (en)',
                houseNumber: 'Номер дома',
                latitude: 'Широта',
                longitude: 'Долгота',
                action: 'Действия'
            },
            latitude: 'Широта*',
            longitude: 'Долгота*',
            edit: 'Редактирование адреса',
            create: 'Создание адреса',
            withoutCoordinates: 'Без координат',
            orderId: 'Номер заказа'
        },
        Bonuses: {
            types: {
                distance: 'По проеханному расстоянию',
                count: 'По количеству заказов'
            },
            targetTypes: {
                all: 'Все',
                taxi: 'Такси',
                delivery: 'Доставка'
            },
            table: {
                type: 'Тип бонусной системы',
                title: 'Название системы',
                description: 'Описание системы',
                bonusFrequency: 'Частота использования бонуса',
                bonusValue: 'Сумма бонуса(грн.)',
                bonusMaxAmount: 'Максимальный размер бонуса',
                bonusMaxOrderAmount: 'Максимальный бонус за заказ',
                fixedBonusAmount: 'Фиксированный бонус',
                targetType: 'Цель',
                startDate: 'Старт программы',
                endDate: 'Окончание программы',
                isActive: 'статус Активный',
                brandId: 'Бренд',
                driverCount: 'Активных водителей',
                receivedBonuses: 'Полученных бонусов',
                actions: 'Действия',
                bonusValueFromDriver: 'Сумма бонуса от водителя(грн.)',
                usersCount: 'Активных пользователей',
                refillBalance: 'Начислено бонусов',
                useBalance: 'Потрачено бонусов',
                leftBalance: 'Осталось бонусов',
                revertBalance: 'Списано бонусов',
                skip: 'Пропусков'
            },
            editor: {
                addBonuses: 'Начислить бонусы',
                addBonusesAgain: 'Начислить бонусы еще раз',
                title: 'Начисление бонусов',
                phoneNumbers: 'Номера телефонов',
                callSigns: 'Позывные водителей',
                bonusAmount: 'Количество бонусов (грн.)',
                bonusSystem: 'Система использования бонусов',
                bonusSystemName: ':bonusValue грн. каждую :bonusFrequency поездку (с :startDate по :endDate)',
                generatedSmsText: 'Вам начислено :amount грн. бонуса. С :startDate по :endDate скидка :bonusValue грн. на каждую :bonusFrequency поездку.',
                generatedSmsTextForDriver: 'Поздравляем! Ты стал участником акции от :brandName. За каждый :bonusFrequency заказ получай :bonusValue грн бонуса',
                transferBonuses: 'Сохранить предыдущие бонусы',
                smsSend: 'Отправить SMS-сообщения',
                smsTransliteration: 'Транслитерировать',
                smsText: 'Текст смс',
                mainTitle: 'Система использования бонусов',
                mainTitleForDriver: 'Система использования бонусов для водителей',
                takeOtherBrandOrders: 'Заказы других служб',
                removeQuestion: 'Хотите удалить бонусную систему?',
                removeDescription: 'Данная бонусная система будет полностью удалена'
            },
            info: {
                callSign: 'Позывной',
                phone: 'Номер телефона',
                refillBalance: 'Начислено бонусов',
                useBalance: 'Использовано бонусов',
                revertBalance: 'Списанные бонусы',
                leftBalance: 'Не использованные бонусы',
                orderCount: 'Количество поездок',
                bonusOrderCount: 'Количество бонусных поездок',
                receivedBonuses: 'Полученных бонусов',
                brandOrderCount: 'Заказы бренда',
                totalOrderCount: 'Все заказы',
                details: 'Подробная информация',
                noActiveUsers: 'В данной бонусной системе еще нет активных пользователей',
                successAdded: 'Успешно начислено',
                countOfBonuses: 'Количество начисленных бонусов',
                countOfTransferedBonuses: 'Количество начисленных бонусов с других систем'
            },
            validate: {
                success: 'Успешно',
                notFound: 'Не найдено',
                duplicate: 'Дубликаты',
                otherBonusSystem: 'Другие бонусные системы',
                validationError: 'Ошибка валидации'
            }
        },
        DeliveryReports: {
            table: {
                date: 'Дата',
                orderCnt: 'Заказов',
                cancelledCnt: 'Отмененных заказов',
                commissionPercent: 'Процент комиссии',
                paidCommission: 'Оплачено комиссии',
                earned: 'Продано на сумму',
                clearProfit: 'Чистый доход',
                soldSum: 'Сумма проданных товаров',
                brandLoan: 'Долг перед брендом',
                totalCommission: 'Сумма комиссии',
                bonusOrderCnt: 'Количество бонусных заказов',
                productSum: 'Сумма проданных товаров',
                deliveryPrice: 'Сумма доставки',
                driverBonusAmount: 'Сумма доплаты водителям',
                totalRouteLength: 'Сумма расстояний',
                totalMargin: 'Сумма наценки',
                deliveryOrderId: 'Номер заказа',
                callSign: 'Позывной',
                driverDistance: 'Расстояние до заведения',
                forcedOrdersCount: 'Количество автозахватов',
                forcedOrdersAcceptedCount: 'Количество взятых автозахватов',
                forcedOrdersDeclinedCount: 'Количество отказов от автозахватов',
                orderCreated: 'Дата и время создания заказа',
                orderOpened: 'Дата и время открытия заказа',
                orderID: 'Номер заказа',
                openDuration: 'Длительность открытия заказа',
                managerFIO: 'ФИО менеджера',
                finalOrderStatus: 'Итоговый статус заказа',
                orderAccepted: 'Дата и время принятия заказа',
                acceptedDuration: 'Длительность принятия заказа',
                operatorFIO: 'ФИО оператора',
                avgAcceptedDuration: 'Средняя длительность принятия заказа',
                minAcceptedDuration: 'Минимальная длительность принятия заказа',
                maxAcceptedDuration: 'Максимальная длительность принятия заказа',
                ordersCount: 'Количество заказов',
                avgOpenDuration: 'Средняя длительность открытия заказа',
                minOpenDuration: 'Минимальная длительность открытия заказа',
                maxOpenDuration: 'Максимальная длительность открытия заказа',
                successfullyTestOrdersCnt: 'Количество успешных тестовых заказов',
                canceledTestOrdersCnt: 'Количество отмененных тестовых заказов',
                canceledTestOrdersSum: 'Сумма отмененных тестовых заказов',
                canceledOrdersByClientBeforePaymentCnt: 'Количество отмененных заказов клиентом до оплаты',
                canceledOrdersByClientAfterPaymentCnt: 'Количество отмененных заказов клиентом после оплаты',
                canceledOrdersByClientAfterPaymentSum: 'Сумма отмененных заказов клиентом после оплаты',
                canceledOrdersByEstBeforePaymentCnt: 'Количество отмененных заказов заведением до оплаты',
                canceledOrdersByEstAfterPaymentCnt: 'Количество отмененных заказов заведением после оплаты',
                canceledOrdersByEstAfterPaymentSum: 'Сумма отмененных заказов заведением после оплаты',
                taxiOrderId: 'Номер заказа',
                distanceToClient: 'Расстояние до клиента'
            },
            types: {
                dailyProfit: 'Отчет управляющего компании №1',
                brandFinance: 'Финансовый по бренду',
                deliveryDriverBonuses: 'Доплата водителям за доставку',
                productAnalytics: 'Отчет управляющего компании №2',
                forcedAnalyticsAccepted: 'Аналитика взятия автозахватов',
                forcedAnalyticsDeclined: 'Аналитика отказа от автозахватов',
                operatorAnalytics: 'Аналитика работы операторов',
                managerAnalytics: 'Аналитика работы менеджеров',
                operatorMainAnalytics: 'Аналитика работы операторов (общий)',
                managerMainAnalytics: 'Аналитика работы менеджеров (общий)',
                canceledAndTestOrders: 'Отмененные и тестовые заказы',
                forcedAnalyticsDeclinedTaxi: 'Аналитика отказа от автозахватов (такси)',
            },
            categories: {
                financialDeliveryReports: 'Финансовые отчеты доставки',
                forcedAnalytics: 'Работа с курьерами',
                orderProcessingAnalytics: 'Аналитика работы с заказами',
                forcedAnalyticsTaxi: 'Работа с такси',
            },
            all: 'Отчеты доставки',
            allEstablishments: 'Все заведения',
            allBrands: 'Все бренды',
            establishment: 'Заведение',
            brand: 'Бренд'
        },
        Reports: {
            all: 'Отчеты',
            another: 'Другие',
            category: 'Категория',
            orderId: 'Номер заказа',
            report: 'Отчет',
            empty: 'У вас нет доступа к отчетам.',
            query: 'Запрос',
            brand: 'Бренд',
            company: 'Компания',
            startDate: 'Начальная дата',
            endDate: 'Конечная дата',
            startTime: 'Время начала',
            endTime: 'Время окончания',
            table: {
                number: '#',
                name: 'Имя',
                category: 'Категория',
                sqlQuery: 'Sql запрос',
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
                action: 'Действия'
            },
            editor: {
                create: 'Создание отчета',
                edit: 'Редактирование отчета',
                meta: 'SQL метаданные',
                useDates: 'Фильтр по датам',
                useTimes: 'Фильтр по времени',
                useQuery: 'Текстовый запрос',
                useBrand: 'Фильтр по брендам',
                useCorp: 'Для корпоративных клиентов',
                useCompany: 'Фильтр по компаниям',
                removeQuestion: 'Хотите удалить отчет?',
                removeDescription: 'Данный отчет будет полностью удален'
            }
        },
        Users: {
            query: 'Запрос',
            startDate: 'Начальная дата',
            endDate: 'Конечная дата',
            all: 'Все',
            table: {
                userId: '#',
                birthday: 'День рождения',
                fullName: 'ФИО',
                firstName: "Имя",
                establishmentAddress: 'Адрес заведения',
                lastName: 'Фамилия',
                middleName: 'Отчество',
                phoneNumber: 'Телефон',
                email: 'Почта',
                comment: 'Комментарий',
                loginName: 'Логин',
                roleName: 'Роль',
                createdAt: 'Принято на работу',
                updatedAt: 'Уволено',
                lastActiveTime: 'Последняя активность',
                brandId: 'Бренд',
                actions: 'Действия',
                callSign: 'Позывной',
                driverStatus: 'Статус',
                shortCarInfo: 'Автомобиль',
                imei: 'IMEI',
                address: 'Адрес',
                commission: 'Комиссия',
                karma: 'Карма',
                commissionSystem: 'Система Комиссии',
                minBalance: 'Минимальный баланс',
                additionalPhoneNumbers: 'Дополнительные номера',
                additionalAdresses: 'Дополнительные адреса',
                pledge: 'Залог',
                password: 'Пароль',
                canEditClients: 'Отображать заказы других операторов',
                canEditDrivers: 'Возможность редактирования водителей',
                canChangeOptionLevel: 'Возможность изменения уровня опций',
                extendedCapabilities: 'Расширенные возможности',
                leaderId: 'Лидер',
                establishmentId: 'Заведение',
                categoryId: 'Категория',
                establishmentAddressId: 'Адрес заведения',
            },
            client: {
                edit: 'Редактирование клиента',
                create: 'Создание клиента'
            },
            operator: {
                edit: 'Редактирование пользователя',
                create: 'Создание пользователя',
                removeQuestion: 'Желаете удалить данного пользователя?',
                removeDescription: 'Данному пользователю будет установлен статус - удален.',
                company: {
                    edit: 'Редактирование компании',
                    title: 'Название компании'
                }
            },
            driver: {
                edit: 'Редактирование водителя',
                create: 'Создание водителя',
                options: 'Опции',
                tariffs: 'Тарифы',
                removeQuestion: 'Желаете удалить данного водителя?',
                removeDescription: 'Данному водителю будет установлен статус - удален.',
                payments: 'История платежей',
                changePasswordText: 'Установленный пароль:',
                comments: 'Комментарии',
                newComment: 'Новый комментарий',
                reRegistration: 'Последняя проверка',
                additionalDriver: 'Дополнительный аккаунт',
                withoutAdditionalDriver: 'Не подвязан',
                tied: 'Подвязан',
                mainDriver: 'Основной аккаунт',
                present: 'Присутствует',
                deliveryConfidence: 'Допуск к заказам доставки',
                confidenceLevels: {
                    under: 'До',
                    all: 'Все'
                },
                disabled: {
                    title: 'Блокировка непроверенных водителей',
                    text: 'Выберите минимальную дату последней проверки для возможности быть в эфире. С эфира будут сняты все водители, у которых дата последней проверки меньше указанной (или отсутствует вообще)'
                },
                car: {
                    color: 'Цвет',
                    model: 'Модель',
                    make: 'Марка',
                    year: 'Год выпуска',
                    number: 'Гос. номер'
                },
                status: {
                    active: 'В эфире',
                    offline: 'В эфире',
                    disabled: 'Снятый с эфира',
                    online: 'Онлайн',
                    removed: 'Уволен'
                },
                driverOptions: {
                    disable: 'Снять с эфира',
                    enable: 'Вернуть в эфир',
                    edit: 'Редактировать',
                    clearImei: 'Сбросить IMEI',
                    clearCode: 'Сбросить код приложения',
                    sendPassword: 'Отправить пароль'
                },
                passportData: {
                    title: 'Паспортные данные',
                    number: 'Серия и номер',
                    issuedBy: 'Выдан (кем)',
                    issuedWhen: 'Выдан (когда)',
                    identificationCode: 'Идентификационный код'
                }
            },
            payments: {
                addPenalty: 'Оштрафовать',
                addPayment: 'Провести платеж',
                penalty: 'Штраф',
                penaltyComment: 'Комментарий к штрафу',
                payment: 'Платеж',
                commissionText: 'Штраф:',
                balance: 'Баланс',
                paymentTypeByComment: 'Тип платежа (комментарий)',
                paymentType: 'Тип платежа',
                noItems: 'Платежи за заданными параметрами не найдены',
                paymentSum: 'Сумма платежа',
                paymentComment: 'Комментарий к платежу',
                createdAt: 'Дата',
                orderId: 'Заказ',
                fullNameForPayment: 'Внес оплату',
                types: {
                    'manual-replenishment': 'Ручное пополнение',
                    'cashless-sprut': 'Безналичный Sprut',
                    'cashless-manual': 'Безналичный',
                    'cash-out': 'Вывод средств',
                    'receipt': 'Квитанция',
                    'employee': 'Сотрудник',
                    'mistake': 'Ошибка',
                    'transfer-plus': 'Перекидка в +',
                    'transfer-minus': 'Перекидка в -',
                    'penalty': 'Штраф',
                    'return': 'Возврат'
                },
                commission: {
                    recalculate: 'Пересчет комиссии',
                    distance: 'Расстояние (км)',
                    downtime: 'Простой (мин)',
                    warning: 'Комиссия будет изменена при сохранении',
                    total: 'Комиссия составляет'
                }
            }
        },
        Options: {
            optionClass: 'Тип',
            optionName: 'Тариф',
            brand: 'Бренд',
            table: {
                optionName: 'Тариф',
                optionClassId: 'Класс',
                districtId: 'Район',
                description: 'Комментарий',
                startPrice: 'Подача',
                priceForKm: 'Километр',
                priceForWaiting: 'Простой(10мин)',
                minPrice: 'Минимальный заказ(грн.)',
                multiplier: 'Множитель тарифа',
                multiplierForDriver: 'Множитель для водителей(раз)',
                defaultOptions: 'Базовый',
                internal: 'Внутренний',
                hidden: 'Скрытый',
                brandId: 'Бренд',
                actions: 'Действия',
                duplicate: 'Дублировать тариф',
                numberOfSits: 'Количество мест'
            },
            editor: {
                create: 'Создание тарифа для клиентов',
                edit: 'Редактирование тарифа для клиентов',
                removeQuestion: 'Желаете удалить данный тариф?',
                removeDescription: 'Данный тариф будет полностью удален.',
            }
        },
        OptionClasses: {
            list: {
                towing: 'Буксировка',
                apart_delivery: 'Доставка в квартиру',
                'apart-delivery': 'Доставка в квартиру',
                pump: 'Подкачать',
                smoke: 'Подкурить',
                drive: 'Драйв',
                'for-testing': 'Тестовый (QA)',
                corporate: 'Корпорация (безнал.)',
                'child-escort': 'Сопровожд. детей',
                'child-car-seat': 'Автокресло',
                animals: 'Перевозка животных',
                delivery: 'Доставка',
                cashless: 'Безналичный расчёт',
                technical: 'ТД',
                promo: 'Супер-Эконом',
                test: ' Test',
                economy: 'Эконом',
                cargo: 'Грузовое такси',
                forced: 'Forced',
                'pre-order': 'Предварительный заказ',
                wagon: 'Универсал',
                van: 'Минивен',
                comfort: 'Комфорт',
                standart: 'Стандарт',
                premium: 'Премиум',
                bonuses: 'Бонусы',
                'food-delivery': 'Доставка еды',
            },
            table: {
                id: 'Номер',
                className: 'Название',
                actions: 'Действия'
            },
            create: 'Новый класс опций',
            edit: 'Редактирование класса опций',
            remove: 'Удаление класса опций',
            removeQuestion: 'Вы действительно хотите удалить этот класс опций ?'
        },
        PaymentTypes: {
            filters: {
                query: 'Запрос'
            },
            table: {
                name: 'Название',
                description: 'Описание',
                orderRequired: 'Заказ',
                hidden: 'Скрытый',
                createdAt: 'Создано',
                actions: 'Действия'
            },
            create: 'Новый тип платежа',
            edit: 'Редактирование типа платежа',
            remove: 'Удаление типа платежа',
            removeQuestion: 'Вы действительно хотите удалить этот тип платежа ?'
        },
        Commissions: {
            title: 'Комиссия',
            status: 'Статус',
            brand: 'Бренд',
            statusesList: {
                active: 'Активные',
                inactive: 'Неактивные',
                removed: 'Удаленные'
            },
            table: {
                title: 'Название',
                countOfDrivers: 'Количество водителей',
                fixedPerOrder: 'Плата за заказ(грн.)',
                fixedPerDay: 'Плата за день работы(грн.)',
                perDayType: 'Тип платы за день',
                fixedPerWeek: 'Плата за неделю работы(грн.)',
                fixedPerMonth: 'Плата за месяц работы(грн.)',
                fixedPerDeliveryOrder: 'Плата за заказ доставки(грн.)',
                percentagePerDeliveryOrder: 'Процент от заказа доставки(%)',
                deliveryDelay: 'Задержка(сек.)',
                isDefault: 'Основная',
                brandId: 'Бренд',
                hasPrecedenceForForced: 'Приоритет в автозахвате',
                actions: 'Действия'
            },
            perDayTypeOptions: {
                'has-orders': 'За дни с заказами',
                'has-orders-count-per-five': 'За дни с заказами (5 платных дней в неделю)',
                'since-first-login': 'За вход в систему'
            },
            editor: {
                create: 'Создание комиссии для водителей',
                edit: 'Редактирование комиссии для водителей',
                removeQuestion: 'Желаете удалить данную комиссию?',
                removeDescription: 'Данная комиссия будет полностью удалена.',
            },
            borders: {
                title: 'Ценовые пороги',
                actions: 'Действия',
                create: 'Добавление порога комиссии',
                edit: 'Редактирование порога комиссии',
                cancel: 'Отменить редактирование',
                notCommissionBorders: 'Для данной комиссии еще не создано ни одного порога',
                leftBorder: 'Левая граница',
                rightBorder: 'Правая граница',
                staticValue: 'Статическая комиссия',
                percentValue: 'Процентная комиссия'
            },
            transfer: {
                title: 'Перевод водителей c текущей комиссии на выбранную',
                commission: 'Комиссия',
                driversCount: 'Количество водителей: {0}',
                question: 'Вы уверены ?',
                description: 'Все водители, которые используют текущую комиссию, будут переведены на выбранную'
            }
        },
        PhotoReport: {
            edit: 'Редактировать',
            reasonRequestCreate: {
                createReason: 'Создание причины',
                photoType: 'Тип фото',
                createPhotoType: 'Создать тип фото',
                reasonName: 'Название причины'
            },
            reasonRequestsList: {
                reasonName: 'Название причины',
                removeTitle: 'Вы действительно хотите удалить причину?',
                removeDescription: 'Данная причина будет полностью удалена',
                table: {
                    '#': '#',
                    name: 'Причина',
                    photo: 'Тип фото',
                    actions: 'Действия',
                    createdAt: 'Создано'
                }
            },
            photoReportsList: {
                completeTitle: 'Вы действительно хотите завершить фотоотчет?',
                completeDescription: 'Описание завершение фотоотчёта',
                removeTitle: 'Вы действительно хотите удалить фотоотчёт?',
                removeDescription: 'Данный фотоотчёт будет полностью удален',
                editTitle: 'Редактировать фотоотчёт',
                activity: 'Активность',
                activeRequest: 'Активные запросы',
                finishedRequest: 'Завершенные запросы',
                filters: {
                    name: 'Название',
                    reason: 'Причина',
                    brand: 'Бренд',
                    callSign: 'Позывной',
                },
                table: {
                    '#': '#',
                    requestName: 'Название',
                    active: 'Активность',
                    reasonName: 'Причина',
                    acceptedDrivers: 'Принято',
                    rejectedDrivers: 'Отклонено',
                    allDrivers: 'Количество водителей',
                    newDrivers: 'Новый',
                    actions: 'Действия',
                    createdAt: 'Создано',
                }
            },
            requestCreate: {
                filters: {
                    brand: 'Бренд',
                    callSign: 'Позывной',
                    checkCallSign: 'Проверить позывной',
                    callSigns: 'Позывные'
                },
                validation: 'Валидация',
                createRequest: 'Создание запроса',
                reason: 'Причина',
                name: 'Название фотоотчёта',
                optionClass: 'Класс опции',
                commission: 'Комиссия',
                modal: {
                    warning: 'Внимание !',
                    info: 'Если один из выбранных позывных уже был добавлен в существующий фотоотчет с аналогичной причиной, - для этого он будет проигнорирован.'
                }
            },
            review: {
                title: 'Фотоотчет: "{0}"',
                editComment: 'Нажмите Enter чтобы сохранить',
                showPhotoType: 'Показать тип фото',
                hidePhotoType: 'Скрыть тип фото',
                filters: {
                    request: 'Запрос',
                    brand: 'Бренд',
                    status: 'Статус',
                    comment: 'Комментарий'
                },
                table: {
                    '#': '#',
                    callSign: 'Позывной',
                    brand: 'Бренд',
                    name: 'ФИО',
                    auto: 'Авто',
                    phoneNumber: 'Телефон',
                    driverCreatedAt: 'Дат. принятия',
                    commission: 'Комиссия',
                    images: 'Фото',
                    status: 'Статус',
                    comment: 'Комментарий'
                }
            },
            statuses: {
                new: 'Новый',
                empty: 'Пустой',
                remake: 'Переснимается',
                accepted: 'Принято',
                rejected: 'Отклонено'
            },
            validation: {
                success: 'Успешно',
                notFound: 'Не найдено',
                duplicate: 'Дублировано',
                validationError: 'Ошибка валидации',
                inOpenRequest: 'В открытом фотоотчёте'
            }
        },
        CommissionSystems: {
            table: {
                id: 'Номер системы',
                name: 'Название',
                brandId: 'Бренд',
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
                drivers: 'Количество водителей',
                actions: 'Действия',
                period: 'Период',
                startCalcDate: 'Дата начала отсчета',
                onlyForcedOrder: 'Только автозахваты'
            },
            editor: {
                create: 'Создание системы комиссий для водителей',
                edit: 'Редактирование системы комиссий для водителей',
                removeQuestion: 'Желаете удалить данную систему комиссий?',
                removeDescription: 'Данная система комиссий будет полностью удалена.',
            },
            errors: {
                alreadyExistSystem: 'Система с таким названием уже существует',
                systemHasDrivers: 'Система уже используется водителями'
            },
            steps: 'Шаги системы комиссий',
            stepsData: {
                count: 'Количество заказов',
                commissionId: 'Комиссия',
                actions: 'Действия'
            },
            transfer: {
                title: 'Перевод водителей с текущей системы комиссий на выбранную',
                commission: 'Система комиссий',
                driversCount: 'Количество водителей: {0}',
                question: 'Вы уверены ?',
                description: 'Все водители, которые используют текущую систему комиссий, будут переведены на выбранную'
            }
        },
        Penalties: {
            title: 'Штраф',
            brand: 'Бренд',
            table: {
                title: 'Название',
                fixedPenalty: 'Сумма штрафа',
                brandId: 'Бренд',
                actions: 'Действия'
            },
            editor: {
                create: 'Создание штрафа',
                edit: 'Редактирование штрафа',
                removeQuestion: 'Желаете удалить данный штраф?',
                removeDescription: 'Данный штраф будет полностью удален.',
            }
        },
        Logging: {
            models: {
                Client: 'Клиент',
                Driver: 'Водитель',
                Operator: 'Оператор',
                ClientBonus: 'Клиентский бонус',
                Tariff: 'Тариф',
                Resale: 'Перепродажа',
                Penalty: 'Штраф',
                Commission: 'Комиссия',
                CommissionBorder: 'Граница комиссии',
                DriverBonus: 'Водительский бонус',
                Settings: 'Настройки',
                Report: 'Отчет'
            },
            actionType: 'Тип действия',
            user: 'Пользователь',
            table: {
                userId: 'Пользователь',
                actionTypeId: 'Тип действия',
                createdAt: 'Создано',
                action: 'Действие'
            },
            messages: {
                'change-action-type-status': 'Логирование действия "{0}" было {1}',
                'setting-edit': 'Настройки {0} были изменены с {1} на {2}.',
                'withBrand': 'С брендом {0}',
                'setting-change': 'Установлены пользовательские [{0}] настройки для бренда {1}',
                'setting-set-default': 'Установлены стандартные [{0}] настройки для бренда {1}',
                'report-change-access': 'Доступ отчетов изменен для пользователя {0} {1}.',
                'addAccess': 'Добавлен доступ: {0}.',
                'removeAccess': 'Удален доступ: {0}.',
                'categoryReport': 'Категория отчета: ',
                'nameReport': 'Имя отчета: ',
                'report-view': 'Отчет просмотрен [Категория: {0}, Имя: {1}]',
                'change': '{0} с {1} на {2}',
                'add': 'Добавлено {0}: {1}',
                'user-login': 'Вход пользователя {0} {1}',
                'delete': '{0} {1} - удалено',
                'operator-delete': 'Пользователь {0} (логин: {1}) с ролью "{2}" был удален',
                'edit': '{0} {1} - изменено: {2}',
                'create': '{0} - создано с параметрами: {1}',
                'deleteField': 'Удалил {0} {1}',
                'resale-create': 'Перепродажа с {0} на {1} (опция: {2}) была создана с параметрами: {3}',
                'resale-edit': 'Поля перепродажи {0} на {1} (опция: {2}) были изменены: {3}',
                'resale-delete': 'Перепродажа с {0} на {1} (опция: {2}) была удалена',
                'change-driver-status': 'Водитель {0} был {1}',
                'driverStatus': {
                    'active': 'возвращен в эфир',
                    'disabled': 'снят с эфира',
                    online: 'онлайн'
                },
                'enabled': ' включено',
                'disabled': 'выключено',
                'send-driver-password': 'Водителю {0} отправлен пароль',
                'passwordChanged': 'Пароль пользователя',
                'operator-back-to-work': 'Оператор {0} возвращен к работе',
                'financeRemove': '{0} {1} для бренда {2} - удален',
                'add-driver-payment': 'Создан платеж водителю: {0} \nс причиной: {1}\nсуммой: {2}\nкомментарием: {3}',
                'reset-imei': 'Сброшен IMEI у {0} водителя',
                'sqlQuery': 'Sql запрос',
                'meta': 'Meta запрос',
                'karma-change': 'Карма водителя "{0}" была изменена с {1} на {2}',
                'option-level-edit': 'Уровень опций был изменен с {0} на {1}',
                "establishment-type-create": 'Создан тип заведений\n{0}',
                "establishment-type-edit": 'Изменён тип заведений\n{0}',
                "establishment-type-delete": 'Удалён тип заведений c {0}',
                "establishment-category-create": 'Создана категория заведений\n{0}',
                "establishment-category-edit": 'Изменена категория заведений\n{0}',
                "establishment-category-delete": 'Удалена категория заведений c {0}',
                "establishment-create": 'Создано заведение {0}\n',
                "establishment-edit": 'Изменено заведение\n{0}',
                "establishment-delete": 'Удалено заведение c {0}',
                "establishment-restore": 'Восстановлено удалённое заведение c {0}',
                "settings-1km-duration": 'Настройка длительности проезда установлена на {0}',
                "section-create": 'Создан раздел\n{0}',
                "section-edit": 'Изменён раздел\n{0}',
                "section-delete": 'Удалён раздел c {0}',
                "product-create": 'Создан продукт\n{0}',
                "product-edit": 'Изменен продукт\n{0}',
                "product-delete": 'Удалён продукт c {0}',
                "product-restore": 'Восстановлен удалённый продукт c {0}'
            }
        },
        LoggingEditor: {
            table: {
                action: 'Действие',
                enabled: 'Включено'
            }
        },
        Notification: {
            count: 'Количество уведомлений',
            drivers: 'Готовые к отправке',
            filters: {
                selectAll: 'Выбрать всех водителей',
                phones: 'Позывные',
                success: 'Успешно',
                duplicate: 'Дубликаты',
                notFound: 'Не найдено',
                withoutToken: 'Без токена',
                validationError: 'Ошибка валидации'
            },
            message: {
                title: 'Заголовок *',
                body: 'Текст',
                image: 'Ссылка на изображение'
            },
            result: {
                title: 'Результат',
                androidSuccess: 'Android успешно',
                androidFailure: 'Android не успешно',
                iosSuccess: 'iOS успешно',
                iosFailure: 'iOS не успешно'
            },
            error: {
                invalidToken: 'Не верный токен устройства',
                emptyToken: 'Токен устройства не отправлено',
                requiredData: 'Поле с телом запроса не отправлено',
                couldNotParsed: 'Невозможно прочитать тело запроса',
                InvalidRegistration: 'Неверная регистрация',
                NotRegistered: 'Не зарегистрирован',
                InvalidPackageName: 'Неверное имя пакета',
                MismatchSenderId: 'Несоответствие идентификатора отправителя',
                InvalidParameters: 'Неверные параметры',
                MessageTooBig: 'Слишком большое сообщение',
                InvalidDataKey: 'Неверный ключ данных',
                Unavailable: 'Недоступен',
                InternalServerError: 'Внутренняя Ошибка Сервера',
                DeviceMessageRateExceeded: 'Превышена скорость сообщения устройства',
                BadCollapseId: 'Неверный идентификатор',
                BadDeviceToken: 'Неверный токен устройства',
                BadExpirationDate: 'Неверный срок годности',
                BadMessageId: 'Неверный идентификатор сообщения',
                BadPriority: 'Плохой приоритет',
                BadTopic: 'Плохая тема',
                DeviceTokenNotForTopic: 'Токен устройства не принадлежит теме',
                DuplicateHeaders: 'Дублирующиеся заголовки',
                IdleTimeout: 'Время простоя',
                MissingDeviceToken: 'Отсутствует токен устройства',
                MissingTopic: 'Недостающая тема',
                PayloadEmpty: 'Полезная нагрузка пуста',
                TopicDisallowed: 'Тема запрещена',
                BadCertificate: 'Плохой сертификат',
                BadCertificateEnvironment: 'Плохая среда сертификатов',
                ExpiredProviderToken: 'Токен просрочен',
                Forbidden: 'Запрещено',
                InvalidProviderToken: 'Неверный токен провайдера',
                MissingProviderToken: 'Отсутствует токен провайдера',
                BadPath: 'Плохой путь',
                MethodNotAllowed: 'Метод не разрешен',
                Unregistered: 'незарегистрированный',
                PayloadTooLarge: 'Слишком большая полезная нагрузка',
                TooManyProviderTokenUpdates: 'Слишком много обновлений токена провайдера',
                TooManyRequests: 'Слишком много запросов',
                ServiceUnavailable: 'Сервис недоступен',
                Shutdown: 'Неисправность'
            }
        },
        DriverNewsEditor: {
            articleData: 'Данные новости'
        },
        AddDriverArticle: {
            sendTo: {
                all: 'Все',
                selected: 'Выбрать позывные'
            }
        },
        News: {
            selects: {
                all: 'Всем',
                leader: 'Лидерам',
                business: 'Бизнесам'
            },
            count: 'Количество новостей',
            header: 'Информация для партнеров',
            showTo: 'Показать',
            showText: 'Публикация',
            latePublication: 'Отложенная публикация',
            publicationDate: 'Дата публикации',
            publicationTime: 'Время публикации',
            text: 'Текст публикации',
            image: 'Выберите изображение',
            share: 'Выберите реферальный код, чтобы поделиться',
            noCode: 'У вас нет ни одного реферального кода. Создайте его перед тем как поделиться',
            edit: 'Редактирование публикации',
            create: 'Новая публикация',
            shareImageBlock: {
                code: {
                    size: 'Размер кода(px)',
                    position: 'Позиция',
                    positions: {
                        'top-left': 'Сверху слева',
                        'top-right': 'Сверху справа',
                        'bottom-left': 'Снизу слева',
                        'bottom-right': 'Снизу справа'
                    }
                },
                addQRCode: 'Добавить QR код'
            }
        },
        DriverNews: {
            table: {
                id: 'Номер новости',
                createdAt: 'Создана',
                sendTo: 'Кому отправлена',
                status: 'Статус',
                header: 'Заголовок',
                text: 'Текст новости',
                actions: 'Действия'
            },
            status: {
                shown: 'Опубликована',
                hide: 'Спрятана'
            },
            sendTo: {
                all: 'Всем',
                selected: 'Выбранным позывным'
            },
            delete: 'Удалить',
            cancel: 'Отменить',
            deleteTitle: 'Удалить новость?',
            cannotBeUndone: 'Это действие необратимо'
        },
        TechnicalSupport: {
            clientAppeals: {
                title: 'Обращения клиентов',
                table: {
                    id: '№',
                    type: 'Тип звонка',
                    phoneNumber: 'Номер телефона',
                    orderId: 'Номер заказа',
                    status: 'Статус',
                    reason: 'Причина',
                    comment: 'Комментарий',
                    dispatcher: 'Диспетчер',
                    actions: 'Действия'
                }
            },
            callTypes: {
                driver: 'Водитель',
                client: 'Клиент'
            },
            statuses: {
                resolved: 'Решено',
                unresolved: 'Не решено',
                review: 'На рассмотрении',
                transferred: 'Передано администратору',
                rejected: 'Отклонено'
            },
            CardEditor: {
                title: 'Карта-обращение',
                form: {
                    type: 'Кто звонил ?',
                    phoneNumber: 'Номер телефона',
                    orderId: 'Номер заказа',
                    reason: 'Причина',
                    status: 'Статус',
                    comment: 'Комментарий',
                    customReason: 'Введите причину'
                }
            },
            additionalInfo: {
                title: 'Дополнительная информация',
                'client-details': 'По номеру телефона',
                'order-details': 'По номеру заказа',
                orderData: 'Данные по заказу',
                payments: 'Платежи в системе',
                paymentsFromFp: 'Платежи в системе FP',
                fpPaymentsTable: {
                    clientId: 'ID клиента',
                    phoneNumber: 'Номер телефона клиента',
                    orderId: 'Номер транзакции',
                    amount: 'Сумма',
                    status: 'Статус',
                    type: 'Тип',
                    createdAt: 'Создано',
                    new: 'Новый',
                    success: 'Успешно',
                    error: 'Ошибка',
                    sandbox: 'Sandbox'
                },
                fpBalanceHistoryTable: {
                    id: 'ID',
                    taxiOrderId: 'Номер заказа такси',
                    paymentId: 'Номер платежа',
                    change: 'Изменения',
                    balance: 'Баланс',
                    paymentType: 'Тип платежа',
                    createdAt: 'Создано',
                    system: 'Система',
                    cashback: 'Кэшбэк',
                    refill: 'Пополнение',
                    trip: 'Поездка'
                },
                orderHistory: 'Последние заказы',
                balanceHistory: 'Последние изменения баланса',
                fpData: 'Данные в системе FP',
                bonuses: 'Участвует в бонусной системе "{0}" ({1})',
                corporation: 'Относится к корпорации "{0}"',
                group: 'Группа клиентов: {0}',
                cashback: 'Участвует в системе кэшбэка: "{0}"'
            }
        },
        Establishments: {
            table: {
                name: 'Название',
                'name:uk': 'Название (UK)',
                'name:ru': 'Название (RU)',
                'name:en': 'Название (EN)',
                description: 'Описание',
                'description:uk': 'Описание (UK)',
                'description:ru': 'Описание (RU)',
                'description:en': 'Описание (EN)',
                status: 'Статус',
                cookTime: 'Время приготовления',
                minimalPrice: 'Мин. сумма заказа',
                place: 'Адрес',
                type: 'Тип',
                category: 'Категория',
                brand: 'Бренд',
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
                actions: 'Действия',
                order: 'Сортировка',
                position: 'Позиция',
                openTime: 'Время открытия',
                margin: 'Наценка',
                closeTime: 'Время закрытия',
                closedOnAlarm: 'Во время тревоги',
                commission: 'Комиссия'
            },
            remove: {
                title: 'Удаление заведения',
                question: 'Вы действительно хотите удалить заведение?'
            },
            settings: {
                title: 'Настройки',
                minutesPerKilometer: 'Длительность проезда 1км пути'
            },
            active: 'Активно',
            inactive: 'Не активно',
            opened: 'Открыто',
            closed: 'Закрыто',
            closedOnAlarm: 'Закрыто при тревоге',
            openOnAlarm: 'Открыто при тревоге'
        },
        EstablishmentEditor: {
            name: 'Название',
            description: 'Описание',
            status: 'Статус',
            cookTime: 'Время приготовления (мин)',
            minimalPrice: 'Мин. сумма заказа',
            place: 'Адреса',
            type: 'Тип',
            category: 'Категория',
            brand: 'Бренд',
            managerPhoneNumber: 'Номер телефона менеджера',
            create: 'Создание нового заведения',
            edit: 'Редактирование заведения',
            openTime: 'Время открытия',
            closeTime: 'Время закрытия',
            commission: 'Комиссия'
        },
        EstablishmentsCategories: {
            table: {
                name: 'Название',
                'name:uk': 'Название (UK)',
                'name:ru': 'Название (RU)',
                'name:en': 'Название (EN)',
                enabled: 'Статус',
                image: 'Изображение',
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
                actions: 'Действия',
                create: 'Новая категория',
                edit: 'Редактирование категории',
                order: 'Сортировка',
                position: 'Позиция'
            }
        },
        EstablishmentsTypes: {
            table: {
                name: 'Название',
                'name:uk': 'Название (UK)',
                'name:ru': 'Название (RU)',
                'name:en': 'Название (EN)',
                description: 'Описание',
                'description:uk': 'Описание (UK)',
                'description:ru': 'Описание (RU)',
                'description:en': 'Описание (EN)',
                status: 'Статус',
                statuses: {
                    draft: 'Черновик',
                    publish: 'Опубликовано'
                },
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
                actions: 'Действия',
                create: 'Новый тип',
                edit: 'Редактирование типа'
            },
            deletingType: 'Удаление типа заведения',
            areYouSureToDelete: 'Вы действительно хотите тип заведения?'
        },
        Sections: {
            table: {
                name: 'Название',
                'name:uk': 'Название (UK)',
                'name:ru': 'Название (RU)',
                'name:en': 'Название (EN)',
                description: 'Описание',
                status: 'Статус',
                establishmentAddress: 'Адрес заведения',
                statuses: {
                    draft: 'Черновик',
                    publish: 'Опубликовано'
                },
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
                margin: 'Наценка',
                actions: 'Действия',
                create: 'Новый раздел',
                edit: 'Редактирование раздела',
                establishment: 'Заведение',
                order: 'Сортировка',
                position: 'Позиция'
            },
            deleting: 'Удаление раздела',
            areYouSureToDelete: 'Вы уверены, что хотите удалить этот раздел?'
        },
        Products: {
            table: {
                name: 'Название',
                'name:uk': 'Название (UK)',
                'name:ru': 'Название (RU)',
                'name:en': 'Название (EN)',
                weight: 'Количество',
                price: 'Цена',
                establishmentAddress: 'Адрес заведения',
                isByWeight: 'Весовой',
                establishmentPrice: 'Цена (заведение)',
                clientPrice: 'Цена (клиент)',
                shortDescription: 'Краткое описание',
                'shortDescription:uk': 'Краткое описание (UK)',
                'shortDescription:ru': 'Краткое описание (RU)',
                'shortDescription:en': 'Краткое описание (EN)',
                detailedDescription: 'Подробное описание',
                'detailedDescription:uk': 'Подробное описание (UK)',
                'detailedDescription:ru': 'Подробное описание (RU)',
                'detailedDescription:en': 'Подробное описание (EN)',
                status: 'Статус',
                brand: 'Бренд',
                section: 'Раздел',
                image: 'Изображение',
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
                actions: 'Действия',
                published: 'Наличие',
                establishment: 'Заведение'
            },
            quantityTypes: {
                pc: 'шт',
                g: 'г',
                kg: 'кг',
                ml: 'мл'
            },
            create: 'Новый товар',
            dblClickToEdit: 'Нажмите на цену дважды для редактирования',
            edit: 'Редактирование товара',
            remove: {
                title: 'Удаление товара',
                question: 'Вы действительно хотите удалить товар ?'
            },
            statuses: {
                review: 'На рассмотрении',
                draft: 'Черновик',
                'not-available': 'Нет в наличии',
                publish: 'Опубликовано'
            }
        },
        404: {
            title: 'Упс!',
            text: 'Похоже, ты на неизведанной территории. Мы еще не знаем об этой странице. К счастью, мы знаем дорогу назад.',
            return: 'Назад'
        }
    },
    buttons: {
        submit: 'Войти',
        cancel: 'Отменить',
        save: 'Сохранить',
        change: 'Изменить',
        remove: 'Удалить',
        selectAll: 'Выбрать все',
        check: 'Проверить',
        edit: 'Редактировать',
        upload: 'Загрузить',
        returnToSearch: 'Вернуть в поиск',
        reset: 'Сбросить',
        excel: 'Скачать таблицу',
        apply: 'Применить',
        ok: 'OK',
        find: 'Найти',
        clear: 'Очистить',
        create: 'Создать',
        validate: 'Проверить',
        generate: 'Сгенерировать',
        generateInExcel: 'Сгенерировать в Excel',
        backToWork: 'Вернуть на работу',
        hide: 'Скрыть',
        send: 'Отправить',
        complete: 'Завершить',
        blocked: 'Заблокировать',
        add: 'Добавить',
        recalculate: 'Пересчитать',
        confirm: 'Подтвердить',
        restore: 'Восстановить',
        transfer: 'Перевести',
        duplicate: 'Дублировать',
        browse: 'Выбрать',
        checkPhones: 'Проверить номера',
        search: 'Искать'
    },
    roles: {
        all: 'Все',
        intern: 'Стажер',
        operator: 'Оператор',
        accountant: 'Бухгалтер',
        manager: 'Менеджер',
        'corporate-admin': 'Корпоративный администратор',
        'corporate-user': 'Корпоративный пользователь',
        boss: 'Директор',
        admin: 'Администратор',
        client: 'Клиент',
        'sales-manager': 'Менеджер по продажам',
        driver: 'Водитель',
        leader: 'Лидер',
        'admin-delivery': 'Администратор доставки',
        'admin-establishment': 'Администратор ресторана',
        'manager-establishment': 'Менеджер ресторана',
        'manager-establishment-ext': 'Менеджер ресторана (расширенный)'
    },
    locales: {
        en: 'English',
        ru: 'Русский',
        uk: 'Українська'
    },
    messages: {
        error: {
            badRequest: 'Заполните все поля',
            missedImportCsv: 'В архиве нет файла import.csv (.xml)',
            uploadFileError: 'Ошибка в файле import.csv (.xml)',
            orderNotFound: 'Заказ не найден',
            borderIsAlreadyExist: 'Границы данного порога пересекаются с границами другого порога',
            existPaymentByPenalty: 'В системе уже есть платежи с данным штрафом.',
            duplicateCallSign: 'Пользователь с данным позывным уже существует. Выберите другой позывной.',
            cantDeleteCorpAdmin: "Невозможно удалить администратора корпорации при наличии пользователей",
            duplicateLoginName: 'Пользователь с данным логином уже существует. Выберите другой логин.',
            duplicatePhoneNumber: 'Пользователь с выбранным номером телефона уже существует.',
            invalidPhone: 'Некорректный номер телефона',
            autologout: 'Сессия была закрыта из-за отсутствия активности',
            invalidLogin: 'Логин не корректный',
            invalidPassword: 'Пароль не корректный',
            requiredPhoneNumber: 'Введите SIP',
            invalidOperator: 'Оператор не найден',
            accountRemoved: 'Аккаунт был удален',
            invalidInteger: 'Нужно записать целочисленное значение. Например: 100',
            invalidDecimal: 'Нужно записать дробное или целочисленное значение. Например: 20 или 20.5',
            invalidBoolean: 'Возможны только значения "true" или "false"',
            invalidFormat: 'Некорректный формат данных',
            withoutType: 'Неправильно указан тип значения или тип значения не передан',
            driversNotFound: 'Водителей не найдено',
            findRequestWithThisReason: 'Невозможно удалить причину, при наличии активного фотоотчёта с этой причиной',
            cannotChangeReason: 'Невозможно изменить причину, при наличии активного фотоотчёта с этой причиной',
            requestAlreadyCompleted: 'Фотоотчет уже завершен',
            notFoundCallSign: 'Позывные не найдены',
            imageIsTooLarge: 'Загрузите фото размера <5мб',
            unknown: 'Неизвестная ошибка',
            brand: {
                alreadyExists: 'Бренд с таким телефоном или кодом уже существует',
                brandNotFound: 'Бренд не найден'
            },
            notifications: {
                InvalidRegistration: 'Неверная регистрация',
                NotRegistered: 'Не зарегистрирован',
                InvalidPackageName: 'Неверное имя пакета',
                MismatchSenderId: 'Несоответствие идентификатора отправителя',
                InvalidParameters: 'Неверные параметры',
                MessageTooBig: 'Слишком большое сообщение',
                InvalidDataKey: 'Неверный ключ данных',
                Unavailable: 'Недоступен',
                InternalServerError: 'Внутренняя Ошибка Сервера',
                DeviceMessageRateExceeded: 'Превышена скорость сообщения устройства',
                invalidToken: 'Не верный токен устройства',
                emptyToken: 'Токен устройства не отправлено',
                requiredData: 'Поле с телом запроса не отправлено',
                couldNotParsed: 'Невозможно прочитать тело запроса',
                noRecords: 'Не найдено ни одной записи',
                unknown: 'Неизвестная ошибка',
                preOrderTime: 'Некорректное время предзаказа'
            },
            payments: {
                emptyPayment: "Невозможно провести пустой платеж.",
                zeroPayment: "Невозможно провести нулевой платеж.",
                emptyPenalty: "Сумма должна быть больше 0 грн.",
                isNotNumericPaymentSum: "Сумма должна быть в числовом формате.",
                moreThenMaxBalance: "Невозможно провести операцию на сумму больше 1 000 000 грн.",
                lessThenMinBalance: "Невозможно провести операцию на сумму меньше 1 000 000 грн.",
                emptyPaymentTypeId: "Тип платежа не указан",
                invalidPaymentTypeId: "Тип платежа не найдено",
                emptyOrderId: "Номер заказа не указан",
                findMoreThanOnePayment: "Платеж уже существует!",
                orderNotFound: "Заказ отсутствует или принадлежит другому водителю"
            },
            support: {
                paymentsNotFound: 'Платежи не найдены',
                orderNotFound: 'Заказ не найден',
                incorrectPhoneNumber: 'Некорректный номер телефона',
                clientNotFound: 'Клиент не найден'
            },
            addresses: {
                alreadyExist: 'Адрес с указанными параметрами уже существует!'
            },
            forms: {
                alreadyHasAnswers: 'Этот вопрос имеет ответы'
            },
            optionClasses: {
                notFound: 'Класс опций не найден',
                foundOptions: 'Найдены опции этого класса'
            },
            paymentTypes: {
                notFound: 'Тип платежа не найден',
                foundPayments: 'Найдены платежи этого типа'
            },
            cantReturnRemovedDriver: 'Вы не можете вернуть уволенного водителя в эфир',
            optionClassExist: 'Эта опция уже выбрана для другого бренда',
            cantCancelActiveOrder: 'Вы не можете отменить данный заказ, пока он открыт',
            wrongToken: 'Неверный авторизационный токен',
            requiredAuthorizationToken: 'Нужен авторизационный токен',
            driverInActivePhotoReport: 'Этот водитель в активном фотоотчёте',
            lessThanMin: 'Меньше минимального значения',
            moreThanMax: 'Больше максимального значения',
            driverRestricted: 'Этот водитель не принадлежит Вашему бренду',
            tooManyChars: 'Слишком много символов',
            fileSizeExceeded: 'Максимальный размер файла: {0} мб'
        },
        success: {
            deletedArticle: 'Новость была удалена',
            savedArticle: 'Новость сохранена',
            createdArticle: 'Новость создана',
            copy: 'Cкопировано в буфер обмена',
            foundCallSign: 'Позывной найден',
            createdPhotoRequest: 'Фотоотчет создан для {0} водителей',
            closedPhotoRequest: 'Фотоотчет успешно завершен',
            success: 'Операция успешно выполнена',
            duplicate: 'Заказ успешно продублирован'
        }
    },
    browserNotify: {
        message: 'Уведомление',
        applyNotifications: 'Вы разрешили показывать браузерные сообщения',
        new: 'Новый заказ',
        cancel: 'Заказ отменен',
        sos: 'SOS вызов',
        late: 'Опоздание на заказ',
        client: 'Клиент: ',
        address: 'Адрес: ',
        availability: 'Нет свободных машин',
        clientRefused: 'Отменен клиентом',
        driver: 'Отменен водителем',
        operator: 'Отменен оператором',
    },
    statuses: {
        all: 'Все',
        new: 'Новый',
        waiting: 'В ожидании',
        searching: 'Поиск водителя',
        arrived: 'Прибыл',
        accepted: 'Назначено',
        landed: 'C пассажиром',
        completed: 'Завершено',
        cancelled: 'Отменено',
        pause: 'Заказ приостановлен',
        delivery: {
            all: 'Все',
            new: 'Новый',
            accepted: 'Принят',
            canceledKitchen: "Отменен кухней",
            notAccepted: "Не принят",
            paid: "Оплачен",
            paymentWait: "Ожидание оплаты",
            cooking: "Готовится",
            canceledClient: "Отменен клиентом",
            canceledClientPayment: "Отменено (после оплаты)",
            readyForDelivery: "Готов к отправке",
            handedToCourier: "Передан курьеру",
            delivered: "Доставлен",
            null: 'Нет информ.',
            undefined: 'Нет информ.'
        }
    },
    scopes: {
        taxi: 'Такси',
        delivery: 'Доставка',
        all: 'Все'
    },
    actionTypes: {
        'setting-edit': 'Редактирование настроек',
        'setting-change': 'Изменение настроек',
        'setting-set-default': 'Установление настроек по умолчанию',
        'report-change-access': 'Изменение доступа отчета',
        'report-view': 'Просмотр отчета',
        'client-create': 'Создание клиента',
        'client-edit': 'Редактирование клиента',
        'driver-create': 'Создание водителя',
        'driver-edit': 'Редактирование водителя',
        'driver-delete': 'Удаление водителя',
        'operator-create': 'Создание оператора',
        'operator-edit': 'Редактирование оператора',
        'operator-delete': 'Удаление оператора',
        'user-login': 'Вход пользователя',
        'client-bonus-create': 'Создание клиентского бонуса',
        'client-bonus-edit': 'Редактирование клиентского бонуса',
        'tariff-create': 'Создание тарифа',
        'tariff-edit': 'Редактирование тарифа',
        'tariff-delete': 'Удаление тарифа',
        'resale-create': ' Создание перепродажи',
        'resale-edit': 'Редактирование перепродажи',
        'resale-delete': 'Удаление перепродажи',
        'commission-create': 'Создание комиссии',
        'commission-edit': 'Редактирование комиссии',
        'commission-delete': 'Удаление комиссии',
        'commission-border-create': 'Создание границы комиссии',
        'commission-border-edit': 'Редактирование границы комиссии',
        'commission-border-delete': 'Удаление границы комиссии',
        'penalty-create': 'Создание штрафа',
        'penalty-edit': 'Редактирование штрафа',
        'penalty-delete': 'Удаление штрафа',
        'driver-bonus-create': 'Создание водительского бонуса',
        'driver-bonus-edit': 'Редактирование водительского бонуса',
        'change-driver-status': 'Изменение статуса водителя',
        'change-action-type-status': 'Изменения в настройках активности',
        'client-bonus-delete': 'Удаление клиентского бонуса',
        'driver-bonus-delete': 'Удаление водительского бонуса',
        'send-driver-password': 'Отправка пароля водителю',
        'operator-back-to-work': 'Возвращение к работе',
        'report-edit': 'Редактирование отчета',
        'report-create': 'Создание отчета',
        'add-driver-payment': 'Создание платежа водителю',
        'reset-imei': 'Сброс IMEI',
        'karma-change': 'Изменение кармы',
        'option-level-edit': 'Изменение уровня опций',
        "settings-1km-duration": 'Настройка длительности проезда',
        "section-create": 'Создание секции',
        "section-edit": 'Изменение секции',
        "section-delete": 'Удаление секции',
        "product-create": 'Создание товара',
        "product-edit": 'Редактирование товара',
        "product-delete": 'Удаление товара',
        "product-restore": 'Восстановление товара',
        "establishment-type-create": 'Создание типа заведений',
        "establishment-type-edit": 'Редактирование типа заведений',
        "establishment-type-delete": 'Удаление типа заведений',
        "establishment-category-create": 'Создание категории заведений',
        "establishment-category-edit": 'Редактирование категории заведений',
        "establishment-category-delete": 'Удаление категории заведений',
        "establishment-create": 'Создание заведения',
        "establishment-edit": 'Редактирование заведения',
        "establishment-delete": 'Удаление заведения',
        "establishment-restore": 'Восстановление удалённого заведения',
    },
    reasons: {
        timeout: 'Большое время подачи',
        all: 'Все',
        'broken-connection': 'Обрыв звонка',
        'no-more-cars': 'Нет машин',
        'not-order': 'Не заказ',
        police: 'ГАИ',
        'client-refused': 'Отменен клиентом',
        breakdown: 'Поломался',
        other: 'Другое',
        null: 'Не SOS',
        'accidental-accept': 'Случайно принят',
        'no-connection-with-driver': 'Нет связи с водителем',
        answerphone: 'Автоответчик'
    },
    driverStatuses: {
        all: 'Все',
        active: 'В эфире',
        disabled: 'Снятые с эфира',
        online: 'Онлайн',
        removed: 'Уволенные',
        offline: 'Оффлайн'
    },
    operatorStatuses: {
        all: 'Все',
        online: 'Онлайн',
        offline: 'Офлайн',
        removed: 'Уволенные'
    },
    timePicker: {
        pm: 'День',
        am: 'Ночь'
    },
    table: {
        load: 'Данные загружаются...',
        noData: 'Данные отсутствуют'
    },
    noDataText: 'Данные отсутствуют',
    dataIterator: {
        loadingText: 'Загрузка'
    },
    carousel: {
        prev: 'Prev',
        next: 'Next'
    },
    date: {
        fromDate: 'Начальная дата',
        toDate: 'Конечная дата',
        date: 'Дата'
    },
    bonusSystem: {
        'true': 'Активная',
        'false': 'Неактивная'
    },
    close: 'Закрыть',
    others: 'других',
    applyFilters: 'Применить фильтры',
    filters: 'Фильтрация',
    system: 'Система',
    status: 'Статус',
    outOf: 'из',
    currency: ' грн',
    answers: {
        yes: 'Да',
        no: 'Нет'
    },
    title: 'Название',
    apiVersion: 'Версия API',
    clientVersion: 'Версия клиента',
    orderId: 'Номер заказа',
    chooseImage: 'Выберите изображение',
    pagination: {
        ariaLabel: {
            previous: 'previous',
            page: 'page',
            next: 'next',
            wrapper: 'wrapper',
            currentPage: 'current page'
        }
    }
};
